"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Box_1 = require("@nerdwallet/currency/components/Box");
var Link_1 = require("@nerdwallet/currency/components/Link");
var sparkle_1 = __importDefault(require("./sparkle"));
var announcement_banner_module_css_1 = __importDefault(require("./announcement-banner.module.css"));
var drawer_context_1 = require("../nerdwallet-plus-drawer-sticky-button/drawer-context");
var AnnouncementBanner = function (_a) {
    var ctaText = _a.ctaText, onClick = _a.onClick, text = _a.text;
    var open = (0, drawer_context_1.useDrawerContext)().open;
    var handleOnClick = function () {
        if (onClick) {
            onClick();
        }
        open();
    };
    return (react_1.default.createElement(Box_1.Box, { alignItems: { desktop: "center", mobile: "flex-start" }, className: announcement_banner_module_css_1.default.container, flexDirection: { desktop: "row", mobile: "column" }, paddingBottom: { desktop: 3, mobile: "3-half" }, paddingTop: { desktop: 3, mobile: "3-half" } },
        react_1.default.createElement(Box_1.Box, { display: { desktop: "inline-flex", mobile: "block" } },
            react_1.default.createElement(Box_1.Box, { marginBottom: { desktop: 0, mobile: 2 }, marginLeft: { desktop: 5, mobile: 3 } },
                react_1.default.createElement(sparkle_1.default, null)),
            react_1.default.createElement(Box_1.Box, { marginBottom: { desktop: 0, mobile: 2 }, marginLeft: { desktop: 2, mobile: 3 }, marginRight: { desktop: 0, mobile: 3 } }, text)),
        react_1.default.createElement(Box_1.Box, { marginLeft: { desktop: 0, mobile: 3 }, marginRight: { desktop: 5, mobile: 3 } },
            react_1.default.createElement(Link_1.Link, { color: "blue-dark", onClick: handleOnClick }, ctaText))));
};
exports.default = AnnouncementBanner;
